var config = require('../config.js')
module.exports = {
  getOrderList: config.host + '/tktinc/api/v1/order/list/c', // 获取订单列表
  orderConfirm: config.host + '/mkatl/api/v1/orderConfirm/c', // 确认订单
  orderSubmit: config.host + '/tktins/api/v1/order/submit/c', // 提交订单
  orderSubmitNew: config.host + '/tktins/api/v1/order/submitNew/c', // 提交订单New：ConfirmId、UseUnifiedPromotion、SelectionMode、SelectedGiftCardIds、ExplicitVipDiscountSelected、SelectedPoint、PreviousQuote
  // orderSubmitRetail: config.host + '/tktins/api/v1/retail-order/submit/c', // 分销提交订单
  orderSubmitRetail: config.host + '/tktins/api/v1/retail-order/submitNew/c', // 分销提交订单New，促销选择字段与 submitNew 一致
  retailManageDetail: config.host + '/retail/api/v1/retailManage/detail/c', // 获取渠道商详情
  orderCancel: config.host + '/tktinc/api/v1/order/cancel/c', // 取消订单
  orderDetail: config.host + '/tktins/api/v1/order/all_detail/c', // 订单详情
  getImageByCode: config.host + '/tktins/api/v1/myTicket/getImageByCode/c', // 获取二维码
  getTicketDynamicCode: config.host + '/tktins/api/v1/myTicket/getTicketDynamicCode/c', // 获取动态二维码
  orderPayMoney: config.host + '/tktins/api/v1/order/start_pay/c', // 立即支付
  userBalanceRecharge: config.host + '/market/api/v1/userBalanceRecharge/recharge/c', // 余额支付
  purchasingCard: config.host + '/market/api/v1/storedCard/purchasingCard/c', // 礼品卡充值
  orderPayList: config.host + '/tktbm/api/v1/switcher/list_pay/c', // 支付列表
  getUserMaxBalance: config.host + '/market/api/v1/allCanPayBalance/getUserMaxBalance/c', // 获取园秀通金额
  orderCheckRepeat: config.host + '/tktins/api/v1/order/submittingid/c', // 检查演出是否重复id
  checkOrderPay: config.host + '/tonpay/api/v1/check/orderPay/c', // 查询订单是否已经支付
  orderDeliveryCost: config.host + '/tktins/api/v1/order-additional/delivery-cost/c', // 查询订单的运费
  myTicketReceivedTickets: config.host + '/tktins/api/v1/myTicket/received-tickets/c', // 票寄送已签收

  smscodeConvert: config.host + '/cid/api/v1/sms-code/convert/v2/c', // 转赠票对象短信验证
  myTicketConvertTicket: config.host + '/tktins/api/v1/myTicket/convertTicket/c', // 转赠票
  

  
  yuanxiuCardConfig: config.host + '/market/api/v1/allCanPayBalance/yuanxiu/cardConfig/c', // 一卡通叠加配置
  
  // 微信小程序订阅消息
  getSubscriptionTemplates: config.host + '/wechat/api/v1/mini-program-subscription-authorizations/c', // 查询当前订单可授权模板
  saveSubscriptionAuthorization: config.host + '/wechat/api/v1/mini-program-subscription-authorizations/c', // 保存用户已同意的授权
  
}